import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyProfile, MyProfilePayload, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload, UpdateProfilePicturePayload, UserSetting, UserSettingPayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { StatusAPIResponse } from "../../../models/information.model";

@Injectable({
  providedIn: 'root',
})

export class ApiUserService {
  private tokenUrl = `${environment.apiPrivateUrl}`;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private apiMethods: ApiMethodService,
  ) { }

  /*############################################# API #################################################*/
  /**
   * ดึงข้อมูลโปรไฟล์ผู้ใช้
   */
  GetProfile(token: string, uid: string): Observable<MyProfile> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    // console.log(this.tokenUrl + '/Cityparking/GetProfile');
    const params = new HttpParams().set('uid', uid);
    return this.http.get<MyProfile>(this.tokenUrl + '/Cityparking/GetProfile', {
      headers,
      params,
    });
  }

  /**
   * อัปเดตชื่อผู้ใช้
   */
  updateNameApi(uid: string, name: string, pictureUrl: string): Observable<CheckRegisterResponse> {
    // const formData = new FormData();
    const body: UpdateNamePayload = {
      uid: uid,
      name: name,
      pictureUrl: pictureUrl,
    };

    // console.log("UpdateProfile : ", body);
    return this.http.post<CheckRegisterResponse>(
      `${this.tokenUrl}/Register/updateName`,
      body,
    );
  }

  /**
   * อัปเดตข้อมูลโปรไฟล์ผู้ใช้
   */
  UpdateProfile(
    body: MyProfilePayload,
    token: string,
  ): Observable<StatusAPIResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<StatusAPIResponse>(
      this.tokenUrl + '/Cityparking/UpdateProfile',
      body,
      { headers },
    );
  }

  /**
   * อัปเดตรูปภาพโปรไฟล์ผู้ใช้ไปยังระบบหลังบ้านและ LINE
   */
  updateProfilePicture(
    body: UpdateProfilePicturePayload,
  ): Observable<StatusAPIResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<StatusAPIResponse>(
      this.tokenUrl + '/Cityparking/UpdateProfilePicture',
      body,
      { headers },
    );
  }

  /**
   * ดึงข้อมูลการตั้งค่าผู้ใช้
   */
  GetUsersetting(token: string, uid: string): Observable<UserSetting> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    console.log(headers);
    const params = new HttpParams().set('uid', uid);
    return this.http.get<UserSetting>(this.tokenUrl + '/Cityparking/GetUserSetting', {
      headers,
      params,
    });
  }

  /**
   * อัปเดตการตั้งค่าผู้ใช้
   */
  UpdateUserSetting(
    body: UserSettingPayload,
    token: string,
  ): Observable<StatusAPIResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<StatusAPIResponse>(
      this.tokenUrl + '/Cityparking/UpdateUserSetting',
      body,
      { headers },
    );
  }
}
